import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { AuthEffects } from './auth.effects';
import { authReducer } from './auth.reducer';

/**
 * Standalone providers for the `authentication` NgRx feature slice (SEOMS-437).
 * Replaces the former `AuthStoreModule`.
 */
export function provideAuthStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('authentication', authReducer),
    provideEffects([AuthEffects]),
  ]);
}
